<template>
  <div class="page-content page-single-projet">
    <headercomponent ref="header"></headercomponent>
    <div class="inner-content">
      <div class="project-wrapper" v-if="projectLoaded">
        <div class="project-top">
          <div class="title-wrapper">
            <h1 v-html="content.title.rendered"></h1>
            <div class="project-nav">
              <ul class="smalltxt">
                <li><router-link :to="previousProject">← {{ $t('précédent') }}</router-link></li>
                <li><router-link to="/projets">{{ $t('retour') }}</router-link></li>
                <li><router-link :to="nextProject">{{ $t('suivant') }} →</router-link></li>
              </ul>
            </div>
          </div>
          <div class="gallery-wrapper">
            <single-gallery :gallery="slides"></single-gallery>
          </div>
        </div>
        <div class="project-text">
          <div class="labels" v-html="content.acf.labels"></div>
          <div class="description" v-html="content.acf.description"></div>
        </div>
        <div class="project-nav-mobile">
          <ul class="smalltxt">
            <li><router-link :to="previousProject">← {{ $t('précédent') }}</router-link></li>
            <li><router-link to="/projets">{{ $t('retour') }}</router-link></li>
            <li><router-link :to="nextProject">{{ $t('suivant') }} →</router-link></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from '@/axios-config';
import { TimelineMax, Power4, Expo } from 'gsap';
import HeaderComponent from '@/components/Modules/HeaderComponent';
import store from '@/store/store';
import SingleGallery from '@/components/Modules/SingleGallery';

export default {
  name: 'SingleProjet',
  data() {
    return {
      content: null,
      slides: [],
      projectLoaded: false,
      rerenderID: 1,
    };
  },
  created() {
    this.setProjectData();
  },
  mounted() {
    setTimeout(() => {
      window.scroll(0, 1);
    }, 1000);
    const tl = new TimelineMax();
    tl.to('.project-nav ul.smalltxt li', 1, { autoAlpha: 1, x: 0, ease: Power4.easeOut }, 3);
  },
  methods: {
    setProjectData() {
      api.get(`projet?_embed&slug=${this.$route.params.slug}`).then(response => {
        this.content = response.data[0];
        this.slides = [];
        response.data[0].acf.gallerie.forEach(element => {
          const nameOfImageCloudinary = element.url.split('/').pop();
          this.slides.push(nameOfImageCloudinary);
        });
        this.projectLoaded = true;
        this.setNavigation();
      });
    },
    setNavigation() {
      store.commit('setPreviousProject', this.content.acf.projet_precedent.post_name);
      store.commit('setNextProject', this.content.acf.projet_suivant.post_name);
      store.commit('setTranslationProject', this.content.acf.traduction_du_projet.post_name);
    },
  },
  components: {
    headercomponent: HeaderComponent,
    'single-gallery': SingleGallery,
  },
  watch: {
    $route() {
      const that = this;
      const logoPaths = document.querySelectorAll('.a11, .a12, .a21, .a22, .s1, .s2');
      const tl = new TimelineMax();
      tl.to('.headerline', 0.8, { scaleX: 0, transformOrigin: '0% 50%', ease: Expo.easeInOut }, 0);
      tl.to(logoPaths, 0.8, { scale: 0, transformOrigin: '0% 50%', ease: Power4.easeInOut }, 0);
      tl.to('footer', 1, { autoAlpha: 0, ease: Power4.easeOut }, 0);
      tl.to('.project-wrapper', 1, { autoAlpha: 0, ease: Power4.easeOut }, 0);
      tl.to('.project-nav', 1, { autoAlpha: 0, ease: Power4.easeOut }, 0);
      tl.add(() => {
        that.setProjectData();
        window.scroll(0, 1);
      }, 1);
      tl.to('.headerline', 1, { scaleX: 1, transformOrigin: '0% 50%', ease: Expo.easeInOut }, 1);
      tl.to(logoPaths, 1, { scale: 1, transformOrigin: '0% 50%', ease: Power4.easeInOut }, 1);
      tl.to('footer', 1, { autoAlpha: 1 }, 1.3);
      tl.to('.project-wrapper', 1, { autoAlpha: 1, ease: Power4.easeOut }, 2);
      tl.to('.project-nav', 1, { autoAlpha: 1, ease: Power4.easeOut }, 2);
    },
    currentlang() {
      this.setProjectData();
    },
  },
  computed: {
    currentlang() {
      return store.state.i18n.locale;
    },
    nextProject() {
      if (store.state.nextProject !== '') {
        return store.state.nextProject;
      }
      return '/';
    },
    previousProject() {
      if (store.state.previousProject !== '') {
        return store.state.previousProject;
      }
      return '/';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins.scss';
.gallery-wrapper {
  overflow: hidden;
  margin-bottom: 45px;
  position: relative;
}
.project-top {
  width: 80%;
  margin: 90px auto 0 auto;
  .title-wrapper {
    display: flex;
    justify-content: space-between;
  }
  h1 {
    margin-bottom: 40px;
    max-width: 50%;
  }
  .project-nav ul {
    display: flex;
    padding-top: 10px;
    li {
      a {
        padding: 0px 10px;
      }
      &:last-of-type {
        a {
          padding-right: 0px;
        }
      }
    }
  }
}
.project-text {
  width: 60%;
  margin: 0 auto 90px auto;
  display: flex;
  .labels {
    width: 34%;
  }
  .description {
    width: 66%;
    /deep/ h5 {
      margin-bottom: 15px !important;
    }
    /deep/ h4 {
      margin-bottom: 35px;
    }
  }
}
.project-nav-mobile {
  display: none;
}
@include md {
  .project-top {
    margin: 80px auto 0 auto;
    h1 {
      max-width: 50%;
      margin-bottom: 35px;
    }
    .gallery-wrapper {
      margin-bottom: 35px;
    }
  }
  .project-text {
    width: 70%;
    margin: 0 20% 80px 10%;
    .labels {
      width: 25%;
    }
    .description {
      width: 70%;
    }
  }
}
@include sm {
  .project-top {
    margin: 65px 15% 0 5%;
    .title-wrapper {
      flex-direction: column;
      .project-nav ul {
        display: none;
      }
    }
    h1 {
      max-width: 75%;
    }
  }
  .project-text {
    width: 80%;
    margin: 0 15% 35px 5%;
    .labels {
      width: 30%;
    }
    .description {
      width: 70%;
    }
  }
  .project-nav-mobile {
    display: block;
    width: 80%;
    margin: 0 15% 0px 5%;
    padding: 15px 0px;
    border-top: 1px solid black;
    border-bottom: 1px solid black;
    ul {
      display: flex;
      justify-content: space-between;
    }
  }
}
@include xs {
  .project-top {
    margin: 50px 15% 0 5%;
  }
  .project-text {
    flex-direction: column-reverse;
    margin-bottom: 35px;
    .description,
    .label {
      width: 100%;
    }
    .description {
      margin-bottom: 20px;
    }
  }
  .project-nav-mobile {
    margin-bottom: 35px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Projet.vue